<script>
export default {
    name: "Message",
    props: ['message'],
    computed: {
        created_at() {
            return moment(this.message.created_at).format('DD.MM.YYYY HH:mm')
        }
    },
}
</script>

<template>
    <div>
        <div v-if="message.author === 'agent'" class="d-flex flex-row justify-content-start">
            <div>
                <p class="small p-2 me-3 mb-1 text-white rounded rounded-lg bg-primary">
                    <span v-if="message.attachments" v-for="a in message.attachments" class="d-block">
                        <a class="text-white" :href="a.url" target="_blank"><span><i class="fas fa-download"></i> {{a.file_name}}</span></a>
                    </span>
                    <span v-if="message.message && message.message.length" class="mr-3">{{message.message}}</span>
                    <span class="small text-white-50">{{created_at}}</span>
                </p>
            </div>
        </div>
        <div v-if="message.author === 'customer'" class="d-flex flex-row justify-content-end">
            <div>
                <p class="small p-2 ms-3 mb-1 rounded rounded-lg" style="background-color: #f5f6f7;">
                    <span v-if="message.attachments" v-for="a in message.attachments" class="d-block">
                        <a :href="a.url" target="_blank"><span><i class="fas fa-download"></i> {{a.file_name}}</span></a>
                    </span>
                    <span v-if="message.message && message.message.length" class="mr-3">{{message.message}}</span>
                    <span class="small text-muted">{{created_at}}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>